import React from "react";

interface MobileHeaderProps {
  sidebarOpen: boolean;
  onToggle: () => void;
}

function MobileHeader({ sidebarOpen, onToggle }: MobileHeaderProps) {
  return (
    <div className="hidden max-md:flex fixed top-0 left-0 right-0 z-[100] px-4 py-3 bg-bg-surface border-b border-border items-center justify-between">
      <span className="text-sm font-semibold text-accent font-mono">EM</span>
      <button
        onClick={onToggle}
        className="bg-transparent border-none text-content text-xl cursor-pointer p-1"
      >
        {sidebarOpen ? "✕" : "☰"}
      </button>
    </div>
  );
}

export default MobileHeader;